import registerDirectives from '../directives'

export default function registerPlugins(app) {

    registerDirectives(app)

}
